import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { SessionService } from 'src/app/services/session.service';
import { environment } from 'src/environments/environment';
import { IAcknowledgementData, IAcknowledgementQuestion, IAcknowledgementsDataModel, IAcknowledgementsWrapperModel } from '../models/veg-wizard-models';
import { Logger } from './logger-service';

@Injectable({
  providedIn: 'root'
})
export class AcknowledgementService {

  constructor(private http: HttpClient,
    private sessionService: SessionService,
    private logger: Logger) {
  }

  getQuestions$(categoryPurposeId: number): Observable<IAcknowledgementQuestion[]> {
    const url = `${environment.apiUrl}/session/acknowledgement-questions/${encodeURIComponent(categoryPurposeId)}`;
    return this.http.get<IAcknowledgementQuestion[]>(url);
  }

  setAcknowledgements$(model: IAcknowledgementsDataModel): Observable<boolean> {

    const sessionId = this.sessionService.getSessionId()!;

    const modelForPost = {
      acknowledgements: [],
      questions: model.questions.map(question => ({
        acknowledgementQuestionId: question.acknowledgementQuestionId,
        description: question.description,
        response: true,
      } as IAcknowledgementQuestion)),
      sessionKey: sessionId,
    } as IAcknowledgementsWrapperModel;

    if (model.clearingInAForestArea != null && model.clearingInAForestArea.response != null) {

      const clearingInAForestAreaAcknolwedgement = ({
        message: model.clearingInAForestArea.message,
        response: model.clearingInAForestArea.response,
      }) as IAcknowledgementData;

      modelForPost.acknowledgements.push(clearingInAForestAreaAcknolwedgement);
    }

    if (model.stateCommercialTimberRights != null && model.stateCommercialTimberRights.response != null) {
      const stateComercialTimerRightsAck = ({
        message: model.stateCommercialTimberRights.message,
        response: model.stateCommercialTimberRights.response,
      } as IAcknowledgementData);

      modelForPost.acknowledgements.push(stateComercialTimerRightsAck);
    }

    if (model.koalaHabitatProtection != null && model.koalaHabitatProtection.response != null) {
      const koalaHabitatProtectionAck = ({
        message: model.koalaHabitatProtection.message,
        response: model.koalaHabitatProtection.response,
      } as IAcknowledgementData);

      modelForPost.acknowledgements.push(koalaHabitatProtectionAck);
    }

    if (model.wetTropicsQldWorldHeritageArea != null && model.wetTropicsQldWorldHeritageArea.response != null) {
      const wetTropicsQldWorldHeritageAreaAck = ({
        message: model.wetTropicsQldWorldHeritageArea.message,
        response: model.wetTropicsQldWorldHeritageArea.response,
      } as IAcknowledgementData);

      modelForPost.acknowledgements.push(wetTropicsQldWorldHeritageAreaAck);
    }

    const url = `${environment.apiUrl}/session/set-acknowledgements`;

    return this.http.post(url, {...modelForPost})
      .pipe(
        catchError((err: HttpErrorResponse) => {
          this.logger.error('setAcknowledgements error', err);
          return of(false)
        }),
        map(() => true) // return true, as it should be HttpStatusCode OK
      );
  }
}
